// material-ui
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import BaseUrlSelector from '../BaseUrlSelector';

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

export default function AuthFooter() {
  return (
    <Container
      maxWidth="xl"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Stack
        spacing={2}
        textAlign="center"
        sx={{ alignItems: 'center' }}
      >
        <Typography variant="subtitle2" color="secondary">
          Powered by{' '}
          <Typography
            component={Link}
            variant="subtitle2"
            href="https://shucontech.in/"
            target="_blank"
            underline="hover"
          >
          Shucon MedAI 
          </Typography>{' '}
          <span style={{ fontSize: '0.6rem' }}>
            (Shucon Solutions Pvt Ltd)
          </span>
        </Typography>
      </Stack>
      <BaseUrlSelector />
    </Container>
  );
}
